import FileUploadStore from '../components/AddRequestDrawer/stores/FileUploadStore'
import { regComp } from '../utils/utils/DI'
import ParseNumberStore from '../utils/utils/ParseNumberStore'
import DataSettingsStore from '../views/DataSettings/store/DataSettingsStore'
import RequestTableSettingsStore from '../views/RequestsManagement/stores/RequestTableSettingsStore'
import ServiceSelectOrdersStore from '../views/Service/stores/ServiceSelectOrdersStore'
import ServiceStore from '../views/Service/stores/ServiceStore'
import AuthorsStore from './AuthorsStore'
import CategoriesStore from './CategoriesStore'
import DealerContractStore from './DealerContractStore'
import DealersStore from './DealersStore'
import InstallationReasonStore from './InstallationReasonStore'
import OrdersStore from './OrdersStore'
import PhotoSettingsStore from './PhotoSettingsStore'
import ProjectVersionStore from './ProjectVersionStore'
import SendersStore from './SendersStore'
import SourcesStore from './SourcesStore'
import StatusesStore from './StatusesStore'
import TerritoryStore from './TerritoryStore'
import UserInfoStore from './UserInfoStore'

regComp(OrdersStore, 'OrdersStore', true)
regComp(StatusesStore, 'StatusesStore', true)
regComp(DealersStore, 'DealersStore', true)
regComp(ServiceStore, 'ServiceStore', true)
regComp(ServiceSelectOrdersStore, 'ServiceSelectOrdersStore', true)
regComp(RequestTableSettingsStore, 'RequestTableSettingsStore', true)
regComp(FileUploadStore, 'FileUploadStore', true)
regComp(SendersStore, 'SendersStore', true)
regComp(TerritoryStore, 'TerritoryStore', true)
regComp(ParseNumberStore, 'ParseNumberStore', true)
regComp(DealerContractStore, 'DealerContractStore', true)
regComp(CategoriesStore, 'CategoriesStore', true)
regComp(UserInfoStore, 'UserInfoStore', true)
regComp(InstallationReasonStore, 'InstallationReasonStore', true)
regComp(PhotoSettingsStore, 'PhotoSettingsStore', true)
regComp(ProjectVersionStore, 'ProjectVersionStore', true)
regComp(AuthorsStore, 'AuthorsStore', true)
regComp(SourcesStore, 'SourcesStore', true)
regComp(DataSettingsStore, 'DataSettingsStore', true)
